<div class="example-preview">
  <div>
    <ng-template #content6 ngbAutofocus let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title">Pesquisa de boletos</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row rowCustom">
          <div class="col">

            <div class="form-group">
              <label class="form-text" for="responsible"><strong>Responsável</strong></label>
              <span class="form-text" id="responsible"> {{contracts[0].responsibleName}}</span>
            </div>


          </div>

          <div class="col">
            <div class="form-group">
              <label class="form-text" for="totalToDistribute"><strong>Valor da diferença</strong></label>
              <span class="form-text" id="totalToDistribute"> {{totalToDistribute | currency}}</span>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label class="form-text" for="valueDiff"><strong>Valor a distribuir</strong></label>
              <span class="form-text" id="valueDiff"> {{differenceValue | currency}}</span>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label class="form-text" for="parcelSelected"><strong>Parcelas Selecionadas</strong></label>
              <span class="form-text" id="parcelSelected"> {{listLinesSelected.length}}</span>
            </div>
          </div>

        </div>

        <div class="cardAcordeonCustom">
          <div class="cardAcordeonCustom2" *ngFor="let contract of contracts;let i= index;">

            <mat-accordion>
              <mat-expansion-panel [expanded]="i === 0" (opened)="panelOpenState = true"
                (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="row rowCardCustom">

                      <div class="col">
                        <span class="form-text" id="contractNumber"> <strong>Contrato: </strong>
                          {{contract.description}}</span>
                      </div>

                      <div class="col">
                        <span class="form-text" id="contractBeneficiary"><strong>Beneficiário</strong>
                          {{contract.beneficiaryName}}</span>
                      </div>

                      <div class="col">
                        <span class="form-text" id="Entity"> <strong>Entidade</strong>
                          {{contract.legalEntityName}}</span>
                      </div>

                      <div class="col">
                        <span class="form-text" id="System"><strong>Sistema</strong>
                          {{contract.sdaSystemDescription}}</span>
                      </div>

                    </div>

                  </mat-panel-title>
                  <mat-panel-description>

                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="table table-hover tableCustom">
                  <thead>
                    <tr class="colorTrCustom">
                      <th>Vencimento</th>
                      <th>Fatura</th>
                      <th>Responsável</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody class="trTable">
                    <tr (click)="selectLine(billet)"
                      [ngClass]="{'selected': this.listLinesSelected.indexOf(billet.billetId) >= 0}"
                      *ngFor="let billet of contract.billets">

                      <td *ngIf="billet.number !== showHide.element.billetNumber">
                        {{billet.dueDate | date : 'dd/MM/yyyy'}}
                      </td>

                      <td *ngIf="billet.number !== showHide.element.billetNumber">
                        {{billet.number}}
                      </td>

                      <td *ngIf="billet.number !== showHide.element.billetNumber">
                        {{billet.responsibleName}}
                      </td>

                      <td *ngIf="billet.number !== showHide.element.billetNumber">
                        {{billet.totalOpenValue | currency}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </mat-expansion-panel>
            </mat-accordion>

          </div>
        </div>


      </div>

      <div class="modal-footer">
        <ng-template #htmlContentTooltip>

          <div class="footerPreviewCustom">
            <table class="table tableFooterPreviewCustom">
              <tr>
                <th>Parcela</th>
                <th>Valor</th>
                <th>Pago</th>
              </tr>
              <tr *ngFor="let bs of listSelectToolTip">
                <td>{{bs.number}}</td>
                <td>{{bs.value}}</td>
                <td>{{bs.partial?'parcial':'total'}}</td>
              </tr>
            </table>
          </div>

        </ng-template>
        <button type="button" class="btn btn-secondary" (click)="c('Close click'); clear()">Cancelar</button>
        <button type="button" [disabled]="differenceValue > 0 && listLinesSelected.length === 0" class="btn btn-primary"
          (click)="save()">Confirmar</button>
        <mat-icon placement="left" class="iconInfo cursorCustom" triggers="mouseenter:mouseleave" [autoClose]="'inside'"
          [ngbTooltip]="htmlContentTooltip">info</mat-icon>
      </div>
    </ng-template>

    <ng-template #content7 ngbAutofocus let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title">Seleção de pessoas</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row rowCustom">
          <div class="col">
            <div class="row">

              <mat-icon class="colorWarning">warning</mat-icon>
              <p> Não foram encontradas as informações deste boleto. Por favor selecione abaixo um responsável.</p>
            </div>
            <search-person-input [searchType]="searchPersonType" 
                                (personSelectedId)="personSelected($event)" 
                                [filterName]="responsibleName">
            </search-person-input>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click'); clear()">Cancelar</button>
      </div>
    </ng-template>
  </div>
</div>